import { formatPriceWithMark } from '@this/src/util/price/price.util';

type FormatProposalPriceOptions = {
  price: number | null;
  priceWithTax: number | null;
  includeTax: boolean;
};

export const formatProposalPrice = ({ price, priceWithTax, includeTax }: FormatProposalPriceOptions): string => {
  const targetPrice = includeTax ? priceWithTax : price;
  return formatPriceWithMark(targetPrice) ?? '-';
};
